(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-offer-popup"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    /* ================================================================
     *  カートページ クーポン案内ポップアップ — JavaScript
     * ================================================================
     *  Liquid側で初回レンダリングしたメッセージの表示制御と、
     *  カートの非同期操作（+/-/削除）後のリアルタイム再判定を行う。
     *
     *  ■ 仕組み:
     *    - Liquidが埋め込んだJSON設定（data-cart-upsell-config）を読み込み、
     *      Liquid側と同一のアルゴリズムで案内内容を再評価する。
     *    - window.fetch をラップし、Dawn の Cart Ajax API 呼び出し
     *      （/cart/change, /cart/update 等）のレスポンスを非破壊的に監視。
     *    - レスポンスの original_total_price と items から最新状態を取得し、
     *      ポップアップの内容・表示状態を動的に更新する。
     * ================================================================ */

    /* ── JSON設定の読み込み ── */
    var configEl = document.querySelector('[data-cart-upsell-config]');
    if (!configEl) return;

    var config;
    try {
      config = JSON.parse(configEl.textContent);
    } catch (e) {
      return;
    }

    var thresholds = config.thresholds || [];
    var quantityCoupon = config.quantityCoupon;
    var hasQuantityCoupon = quantityCoupon !== null;
    var lowestIndex = thresholds.length - 1;
    var excludeHandles = config.excludeHandles || [];

    /*
     * 仕様4用: フォールバック案内先（最低金額の1つ上の閾値）
     * 個数クーポンがある場合、最低金額クーポンの案内は出さず、
     * 代わりにこの閾値の差額を案内する。
     */
    var fallbackTarget = null;
    if (hasQuantityCoupon && thresholds.length >= 2) {
      fallbackTarget = thresholds[lowestIndex - 1];
    }


    /* ── 金額フォーマット（money_without_trailing_zeros 相当） ── */
    function formatMoney(amountInSubunit) {
      var yen = Math.round(amountInSubunit / 100);
      var formatted = config.moneyFormat.replace(
        /\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/,
        yen.toLocaleString('ja-JP')
      );
      formatted = formatted.replace(
        /\{\{\s*amount_no_decimals\s*\}\}/,
        yen.toLocaleString('ja-JP')
      );
      formatted = formatted.replace(
        /\{\{\s*amount\s*\}\}/,
        yen.toLocaleString('ja-JP')
      );
      return formatted;
    }


    /*
     * ── クーポン詳細のクローン処理 ──
     * .cart-upsell-popup__code-container の data-upcode と同じ値を持つ
     * input.coupon-baloon-content_code-value を検索し、
     * その最も近い親の .coupon-baloon-content_detail をクローンして
     * コンテナ内に複製する。
     */
    function cloneCouponDetail(container) {
      if (!container) return;
      var upcode = container.getAttribute('data-upcode');
      if (!upcode) return;
      container.innerHTML = '';
      var codeInput = document.querySelector(
        'input.coupon-baloon-content_code-value[value="' + CSS.escape(upcode) + '"]'
      );
      if (codeInput) {
        var detail = codeInput.closest('.coupon-baloon-content_detail');
        if (detail) {
          container.appendChild(detail.cloneNode(true));
        }
      }
    }


    /*
     * ── Cart APIレスポンスから除外対象を除いた個数を算出 ──
     * gift-wrapping 等の除外ハンドルに一致するアイテムはカウントしない。
     * Cart Ajax APIのレスポンスの items[].handle で判定する。
     */
    function countEligibleItems(items) {
      var count = 0;
      for (var i = 0; i < items.length; i++) {
        if (excludeHandles.indexOf(items[i].handle) === -1) {
          count += items[i].quantity;
        }
      }
      return count;
    }


    /*
     * ── メイン判定ロジック（Liquid側と同一アルゴリズム） ──
     * カート合計金額と有効個数から、表示すべき案内を決定する。
     *
     * 戻り値:
     *   null                                    → 案内なし
     *   { type: 'price', remain: N, code: '…' } → 金額差額の案内
     *   { type: 'count', remain: N, code: '…' } → 残り個数の案内
     */
    function evaluate(cartTotal, cartCount) {
      /* カートが空なら案内なし */
      if (cartCount === 0) return null;

      /* 金額閾値を降順に走査 */
      for (var i = 0; i < thresholds.length; i++) {
        var threshold = thresholds[i].yen * 100;
        var code = thresholds[i].code;

        /* 最大閾値以上 → 案内なし */
        if (i === 0 && cartTotal >= threshold) {
          return null;
        }

        if (cartTotal < threshold) {
          var nextI = i + 1;

          if (nextI < thresholds.length) {
            /* 次の閾値以上 → 現在の閾値のクーポンを案内 */
            var nextThreshold = thresholds[nextI].yen * 100;
            if (cartTotal >= nextThreshold) {
              return { type: 'price', remain: threshold - cartTotal, code: code };
            }
          } else if (i === lowestIndex) {
            /*
             * 最低閾値未満で、次の閾値がない。
             * 仕様4: 個数クーポンがあればこの閾値の案内は出さない。
             */
            if (!hasQuantityCoupon) {
              return { type: 'price', remain: threshold - cartTotal, code: code };
            }
          }
        }
      }

      /*
       * フォールバック: 個数クーポンによる判定
       * 仕様4: 個数条件を満たしている場合、最低金額ではなく
       * 1つ上の閾値（fallbackTarget）の差額を案内する。
       */
      if (hasQuantityCoupon) {
        if (cartCount >= quantityCoupon.min && fallbackTarget) {
          var targetThreshold = fallbackTarget.yen * 100;
          return { type: 'price', remain: targetThreshold - cartTotal, code: fallbackTarget.code };
        } else {
          return { type: 'count', remain: quantityCoupon.min - cartCount, code: quantityCoupon.code };
        }
      }

      return null;
    }


    /* ── 古い code-container を全て除去（重複防止） ── */
    function removeStaleCodeContainers(popup) {
      var stale = popup.querySelectorAll('.cart-upsell-popup__code-container');
      for (var i = 0; i < stale.length; i++) {
        stale[i].remove();
      }
    }


    /* ── ポップアップにメッセージがあるか判定 ── */
    function popupHasMessage(popup) {
      var contentEl = popup.querySelector('.cart-upsell-popup__content');
      return contentEl && contentEl.innerHTML.trim() !== '';
    }


    /* ── ポップアップをタブごと完全に非表示にする ── */
    function hideCompletely(popup) {
      popup.classList.remove('is-shown', 'is-visible', 'is-collapsed');
      popup.setAttribute('aria-hidden', 'true');
    }


    /*
     * ── ポップアップの内容を動的に更新する ──
     * Cart Ajax API のレスポンスから得た最新のカート情報で
     * 案内内容を再評価し、DOMを書き換える。
     *
     * - result が null → メッセージをクリアしてタブごと完全非表示
     * - result がある → メッセージを生成してクーポン詳細をクローン
     *   - ユーザーが手動で閉じた状態（is-collapsed）なら開き直さない
     */
    function updatePopup(cartTotal, cartCount) {
      var popup = document.querySelector('[data-cart-upsell-popup]');
      if (!popup) return;

      var contentEl = popup.querySelector('.cart-upsell-popup__content');
      if (!contentEl) return;

      /* 更新前に古い code-container を確実に除去（重複防止） */
      removeStaleCodeContainers(popup);

      var result = evaluate(cartTotal, cartCount);

      if (result === null) {
        contentEl.innerHTML = '';
        hideCompletely(popup);
        return;
      }

      var html;
      if (result.type === 'price') {
        html =
          '<div class="cart-upsell-popup__text">あと<span class="cart-upsell-popup__text-price">' +
          formatMoney(result.remain) +
          '</span>で使えるクーポンがあります！</div>' +
          '<div class="cart-upsell-popup__code-container" data-upcode="' +
          result.code +
          '"></div>';
      } else {
        html =
          '<div class="cart-upsell-popup__text">あと<span class="cart-upsell-popup__text-price">' +
          result.remain +
          '点購入</span>で使えるクーポンがあります！</div>' +
          '<div class="cart-upsell-popup__code-container" data-upcode="' +
          result.code +
          '"></div>';
      }

      contentEl.innerHTML = html;

      var codeContainer = contentEl.querySelector('.cart-upsell-popup__code-container');
      cloneCouponDetail(codeContainer);

      popup.classList.add('is-visible');
      if (!popup.classList.contains('is-collapsed')) {
        popup.classList.add('is-shown');
        popup.setAttribute('aria-hidden', 'false');
      }
    }


    /*
     * ── fetch インターセプト ──
     * Dawn の cart.js は updateQuantity 内で fetch('/cart/change', ...) を呼ぶ。
     * レスポンスには original_total_price, item_count, items 等が含まれる。
     * response.clone().json() で非破壊的に読み取り、Dawn側の処理に干渉しない。
     * /cart/change, /cart/update, /cart/add, /cart/clear を監視対象とする。
     */
    var originalFetch = window.fetch;
    window.fetch = function () {
      var args = arguments;
      var url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';

      return originalFetch.apply(this, args).then(function (response) {
        if (
          /\/cart\/(change|update|add|clear)(\.js)?(\?|$)/.test(url)
        ) {
          response.clone().json().then(function (data) {
            var total = data.original_total_price;
            var items = data.items;
            if (typeof total === 'number' && Array.isArray(items)) {
              /* 除外ハンドルを除いた有効個数を算出 */
              var eligibleCount = countEligibleItems(items);
              updatePopup(total, eligibleCount);
            }
          }).catch(function () {});
        }
        return response;
      });
    };


    /* ── DOMContentLoaded: 初回表示制御 ── */
    document.addEventListener('DOMContentLoaded', function () {
      var popup = document.querySelector('[data-cart-upsell-popup]');
      if (!popup) return;

      /*
       * タブの開閉リスナーは常に登録する。
       * 初回メッセージがなくても、非同期更新後にポップアップが
       * 表示された場合にタブが機能する必要があるため。
       */
      var toggleButton = popup.querySelector('[data-cart-upsell-popup-toggle]');
      if (toggleButton) {
        toggleButton.addEventListener('click', function () {
          /* メッセージがなければ何もしない */
          if (!popupHasMessage(popup)) return;

          if (popup.classList.contains('is-shown')) {
            /* 開いている → 閉じる（タブだけ残る） */
            popup.classList.remove('is-shown');
            popup.classList.add('is-collapsed');
            popup.setAttribute('aria-hidden', 'true');
          } else {
            /* 閉じている → 開く */
            popup.classList.add('is-shown');
            popup.classList.remove('is-collapsed');
            popup.setAttribute('aria-hidden', 'false');
          }
        });
      }


      /*
       * ── クーポンコピーボタンの GA4 イベント送信 ──
       * .js-coupon-copy は .cart-upsell-popup__code-container 内に
       * 動的にクローンされた要素のため、イベント委譲で捕捉する。
       * gtag() でカスタムイベント「cart_offer_coupon_copy」を送信し、
       * クーポンコード（data-upcode）をパラメータとして渡す。
       *
       * ※ GA4のイベント名にはハイフンが使えないためアンダースコアで統一する
       */
      popup.addEventListener('click', function (e) {
        var copyBtn = e.target.closest('.js-coupon-copy');
        if (!copyBtn) return;

        var codeContainer = copyBtn.closest('.cart-upsell-popup__code-container');
        var couponCode = codeContainer
          ? codeContainer.getAttribute('data-upcode')
          : '';

        if (typeof gtag === 'function') {
          gtag('event', 'cart_offer_coupon_copy', {
            cart_offer_coupon_code: couponCode
          });
        }
      });


      /* 初回クーポン詳細クローン */
      var codeContainer = popup.querySelector('.cart-upsell-popup__code-container');
      cloneCouponDetail(codeContainer);

      /* 初回メッセージがなければタブごと完全非表示（スクロールトリガーも不要） */
      if (!popupHasMessage(popup)) {
        hideCompletely(popup);
        return;
      }

      /*
       * スクロールトリガーで初回表示。
       * ページ読み込み直後ではなく、一定量スクロールしてから表示する。
       */
      var triggerScrollY = 180;
      var hasTriggered = false;

      function onScrollTrigger() {
        if (hasTriggered) return;
        if (!popupHasMessage(popup)) return;
        hasTriggered = true;
        popup.classList.add('is-visible', 'is-shown');
        popup.setAttribute('aria-hidden', 'false');
        window.removeEventListener('scroll', onScrollTrigger);
      }

      function handleScroll() {
        if (window.scrollY >= triggerScrollY) {
          onScrollTrigger();
        }
      }

      window.addEventListener('scroll', handleScroll, { passive: true });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["crm-modal-popup"] && !Shopify.designMode) return;
  try {
    (function () {
  /* =============================================
   * 調整用パラメータ
   * ============================================= */
  var CRMPOP_CONFIG = {
    SCROLL_THRESHOLD: 30,       /* スクロール率（%）     */
    IDLE_TIMEOUT:     15,       /* 無操作判定（秒）      */
    STORAGE_KEY: 'crmpop-shown'
  };

  /* =============================================
   * 要素取得 & 表示済みチェック
   * ============================================= */
  var crmpopOverlay  = document.getElementById('crmpop-overlay');
  var crmpopCloseBtn = document.getElementById('crmpop-close');

  if (!crmpopOverlay || !crmpopCloseBtn) return;

  /* 同一セッションで表示済みなら何もしない */
  try {
    if (sessionStorage.getItem(CRMPOP_CONFIG.STORAGE_KEY)) return;
  } catch (e) { /* private browsing 等で使えない場合は続行 */ }

  var crmpopShown = false;

  /* =============================================
   * モーダル表示 / 非表示
   * ============================================= */
  function crmpopShow() {
    if (crmpopShown) return;
    crmpopShown = true;
    crmpopOverlay.classList.add('crmpop-is-visible');
    crmpopTeardown();
  }

  function crmpopClose() {
    crmpopOverlay.classList.remove('crmpop-is-visible');
    try { sessionStorage.setItem(CRMPOP_CONFIG.STORAGE_KEY, '1'); } catch (e) {}
  }

  /* CTAリンク押下時もフラグを立てる（別窓遷移のため元ページに残る） */
  var crmpopCtas = crmpopOverlay.querySelectorAll('.crmpop-cta');
  crmpopCtas.forEach(function (cta) {
    cta.addEventListener('click', function () {
      try { sessionStorage.setItem(CRMPOP_CONFIG.STORAGE_KEY, '1'); } catch (e) {}

      /* GA4 カスタムイベント送信 */
      try {
        if (typeof window.gtag === 'function') {
          var method = cta.classList.contains('crmpop-cta--line') ? 'line'
                    : cta.classList.contains('crmpop-cta--mail') ? 'mail'
                    : 'unknown';
          window.gtag('event', 'crm_popup_click', {
            crm_popup_method: method
          });
        }
      } catch (e) {}
    });
  });

  crmpopCloseBtn.addEventListener('click', crmpopClose);
  /*
  crmpopOverlay.addEventListener('click', function (e) {
    if (e.target === crmpopOverlay) crmpopClose();
  });
  */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') crmpopClose();
  });

  /* =============================================
   * デバイス判定（768px 以下をスマホとみなす）
   * ============================================= */
  var crmpopIsMobile = window.matchMedia('(max-width: 768px)').matches;

  /* =============================================
   * リスナー管理用（解除できるようにまとめる）
   * ============================================= */
  var crmpopListeners = [];

  function crmpopAddListener(target, event, handler, opts) {
    target.addEventListener(event, handler, opts || false);
    crmpopListeners.push({ target: target, event: event, handler: handler, opts: opts || false });
  }

  function crmpopTeardown() {
    crmpopListeners.forEach(function (l) {
      l.target.removeEventListener(l.event, l.handler, l.opts);
    });
    crmpopListeners = [];
    if (crmpopIdleTimer) clearTimeout(crmpopIdleTimer);
  }

  /* =============================================
   * 条件 1: スクロール n%
   * （PC・スマホ共通）
   * ============================================= */
  function crmpopOnScroll() {
    var scrollTop  = window.pageYOffset || document.documentElement.scrollTop;
    var docHeight  = document.documentElement.scrollHeight;
    var winHeight  = window.innerHeight;
    var scrollable = docHeight - winHeight;
    if (scrollable <= 0) return;
    var percent = (scrollTop / scrollable) * 100;
    if (percent >= CRMPOP_CONFIG.SCROLL_THRESHOLD) crmpopShow();
  }
  crmpopAddListener(window, 'scroll', crmpopOnScroll, { passive: true });

  /* =============================================
   * 条件 2: 無操作 n秒
   * （PC・スマホ共通）
   * 何らかの操作後にカウント開始
   * ============================================= */
  var crmpopIdleTimer = null;
  var crmpopUserActed = false;
  var CRMPOP_IDLE_EVENTS = ['mousemove', 'touchstart', 'scroll', 'keydown', 'click'];

  function crmpopResetIdle() {
    crmpopUserActed = true;
    if (crmpopIdleTimer) clearTimeout(crmpopIdleTimer);
    crmpopIdleTimer = setTimeout(function () {
      if (crmpopUserActed) crmpopShow();
    }, CRMPOP_CONFIG.IDLE_TIMEOUT * 1000);
  }

  CRMPOP_IDLE_EVENTS.forEach(function (evt) {
    crmpopAddListener(document, evt, crmpopResetIdle, { passive: true });
  });

  /* =============================================
   * 条件 3（PC のみ）: マウスがブラウザ上端に出た
   * ============================================= */
  if (!crmpopIsMobile) {
    function crmpopOnMouseLeave(e) {
      if (e.clientY <= 0) crmpopShow();
    }
    crmpopAddListener(document, 'mouseout', crmpopOnMouseLeave);
  }

  /* =============================================
   * 条件 3（スマホのみ）: ウィンドウが非アクティブ
   * ============================================= */
  if (crmpopIsMobile) {
    function crmpopOnVisibilityChange() {
      if (document.visibilityState === 'hidden') crmpopShow();
    }
    crmpopAddListener(document, 'visibilitychange', crmpopOnVisibilityChange);
  }

})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-info-yt"] && !Shopify.designMode) return;
  try {
    // 商品情報 YouTube ブロック
    // ※ {% javascript %} 内では Liquid は展開されないため、動画IDは data 属性から取得する

    var PYT_ROOT_SELECTOR = '.product_info_yt';
    var PYT_INIT_ATTR = 'data-product-info-yt-init';

    function pytInitAll(scope) {
      var roots = (scope || document).querySelectorAll(PYT_ROOT_SELECTOR + ':not([' + PYT_INIT_ATTR + '])');
      roots.forEach(pytInitOne);
    }

    function pytInitOne(root) {
      root.setAttribute(PYT_INIT_ATTR, '1');

      var videoId = root.getAttribute('data-video-id') || '';
      videoId = videoId.trim();
      if (!videoId) return;

      var thumbBtn = root.querySelector('.product_info_yt__thumb-btn');
      var thumbImg = root.querySelector('.product_info_yt__thumb-img');
      var modal = root.querySelector('.product_info_yt__modal');
      var player = root.querySelector('.product_info_yt__player');
      var closeBtn = root.querySelector('.product_info_yt__close');
      if (!thumbBtn || !modal || !player || !closeBtn) return;

      // --- モーダルのポータル化 ---
      // 祖先に transform / filter / contain 等があると position: fixed の基準が
      // その祖先になり全画面表示できないため、モーダルを body 直下へ移動する
      document.body.appendChild(modal);
      modal._pytRoot = root;

      // --- サムネイルのフォールバック処理 ---
      // maxresdefault が存在しない動画では 404、または 120x90 のプレースホルダーが
      // 返るため、エラー時と naturalWidth<=120 の両方を検知して hqdefault に差し替える
      if (thumbImg) {
        var applyFallback = function () {
          if (thumbImg.getAttribute('data-fallback-applied')) return;
          var fallbackSrc = thumbImg.getAttribute('data-fallback-src');
          if (!fallbackSrc) return;
          thumbImg.setAttribute('data-fallback-applied', '1');
          thumbImg.src = fallbackSrc;
        };
        var checkNaturalWidth = function () {
          if (thumbImg.naturalWidth > 0 && thumbImg.naturalWidth <= 120) applyFallback();
        };
        thumbImg.addEventListener('error', applyFallback);
        thumbImg.addEventListener('load', checkNaturalWidth);
        if (thumbImg.complete) {
          if (thumbImg.naturalWidth === 0) {
            // 読み込み失敗済み（キャッシュ含む）
            applyFallback();
          } else {
            checkNaturalWidth();
          }
        }
      }

      // --- モーダル開閉 ---
      var savedBodyOverflow = '';

      var openModal = function () {
        // iframe はクリック時に初めて生成する（事前読み込みなし）
        var iframe = document.createElement('iframe');
        iframe.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(videoId) + '?autoplay=1&rel=0&playsinline=1';
        iframe.setAttribute('title', 'YouTube video player');
        iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
        iframe.setAttribute('allowfullscreen', '');
        player.appendChild(iframe);

        modal.hidden = false;
        savedBodyOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        closeBtn.focus();
      };

      var closeModal = function () {
        if (modal.hidden) return;
        // iframe を DOM から除去して再生を確実に停止する
        player.innerHTML = '';
        modal.hidden = true;
        document.body.style.overflow = savedBodyOverflow;
        thumbBtn.focus();
      };

      thumbBtn.addEventListener('click', openModal);
      closeBtn.addEventListener('click', closeModal);

      // 背景（オーバーレイ）クリックで閉じる。ダイアログ内クリックは対象外
      modal.addEventListener('click', function (event) {
        if (event.target === modal) closeModal();
      });

      // Esc キー対応のため、閉じる関数をモーダル自身に保持
      modal._pytClose = closeModal;
    }

    // Esc キーで開いているモーダルを閉じる／セクション再読み込み時の後始末
    // （document に1回だけ登録）
    if (!document.documentElement.hasAttribute('data-product-info-yt-esc')) {
      document.documentElement.setAttribute('data-product-info-yt-esc', '1');

      document.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') return;
        document.querySelectorAll('.product_info_yt__modal:not([hidden])').forEach(function (modal) {
          if (typeof modal._pytClose === 'function') modal._pytClose();
        });
      });

      // テーマエディタでセクションが破棄された際、body へ移動済みの
      // モーダルが取り残されるため、元のブロックが消えていたら削除する
      document.addEventListener('shopify:section:unload', function () {
        document.querySelectorAll('.product_info_yt__modal').forEach(function (modal) {
          if (modal._pytRoot && !modal._pytRoot.isConnected) modal.remove();
        });
      });
    }

    pytInitAll();

    // テーマエディタでのセクション再読み込みに対応
    document.addEventListener('shopify:section:load', function (event) {
      pytInitAll(event.target);
    });
  } catch(e) { console.error(e); }
})();

})();
